/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
import '../resources/datatypes';
import '../resources/enums';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CatalogConfigurationRequest": {
                        "fields": {}
                      },
                      "CatalogConfigurationResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "catalogConfiguration": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CatalogConfiguration",
                            "id": 2,
                            "rule": "optional"
                          },
                          "object": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogConfiguration": {
                        "fields": {
                          "defaultInventoryTrackingEnabled": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "defaultItemType": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogItemProductType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "defaultItemSiteVisibility": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.EcomVisibility",
                            "id": 3,
                            "rule": "optional"
                          },
                          "defaultItemChannels": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogConfigurationRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogConfigurationResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogConfiguration) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CatalogConfigurationRequest @ squareup/connect/v2/catalog/interfaces/catalog-configuration.proto at 20:1
 */
export const CatalogConfigurationRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogConfigurationRequest');
fixType(CatalogConfigurationRequest);
Builder.createAndAttachToType(CatalogConfigurationRequest);
/**
 * SOURCE CatalogConfigurationResponse @ squareup/connect/v2/catalog/interfaces/catalog-configuration.proto at 27:1
 */
export const CatalogConfigurationResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogConfigurationResponse');
fixType(CatalogConfigurationResponse);
Builder.createAndAttachToType(CatalogConfigurationResponse);
/**
 * SOURCE CatalogConfiguration @ squareup/connect/v2/catalog/interfaces/catalog-configuration.proto at 44:1
 */
export const CatalogConfiguration = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogConfiguration');
fixType(CatalogConfiguration);
Builder.createAndAttachToType(CatalogConfiguration);